import { useParams } from 'react-router-dom';
import './ProductDetail.css'; 
import Services from "../Services/Services";
import { Helmet } from "react-helmet";
import RentalProduct from '../RentalProduct/RentalProduct';


const productMap = {
  'solar-plant': 'Solar Power Plant',
  'solar-heater': 'Solar Water Heater',
  'street-light': 'Solar Street Light',
  'ups-battery': 'UPS Battery',
  'cctv': 'CCTV',
  'ro-softener': 'RO and Softener',
  'lubricants': 'Lubricants',
  'services':'Services',
  'rental':'Rental Products',
  
};



const solarPlantSections = [
{
    title: 'Domestic Solar Power Plant',
    description: (
      <div>
        <p>
          Domestic solar systems reduce electricity bills and provide a clean, renewable source of power. Ideal for rooftops and small-scale installations, these systems are both cost-effective and eco-friendly.
        </p>
        <h5>PM Surya Ghar Yojana Scheme – Government Subsidy Support</h5>
        <p>
          The Government of India offers financial assistance under the <strong>PM Surya Ghar Yojana</strong> to encourage the adoption of rooftop solar systems. The subsidy is based on the installed capacity:
        </p>
        <table className="table table-bordered mt-3">
          <thead>
            <tr>
              <th>Rooftop Solar Capacity</th>
              <th>Subsidy Support</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1 KW</td>
              <td>₹30,000</td>
            </tr>
            <tr>
              <td>2 KW</td>
              <td>₹60,000</td>
            </tr>
            <tr>
              <td>Above 3 KW</td>
              <td>Flat ₹78,000</td>
            </tr>
          </tbody>
        </table>
        <p>Switch to solar and enjoy long-term savings while contributing to a greener future.</p>
      </div>
    ),
    image: '/images/solar-domestic.jpg',
},
{
  title: 'Commercial Solar Power Plant',
  description: (
    <div>
      <p>Commercial solar systems cater to businesses, factories, and institutions.  
          They offer high-capacity energy generation, ensuring sustainability, cost savings, and reduced dependency on the power grid.<br></br>
      </p>
      <p>Commercial solar energy solutions are ideal for businesses looking to reduce electricity costs, achieve energy independence, and promote sustainability. From <b>factories, warehouses, and corporate offices to hospitals, schools, hotels, and shopping malls, solar power supports various high-energy applications such as lighting, HVAC systems, machinery, IT infrastructure, and critical equipment.</b></p> 
      <p>Rooftop solar installations with net metering help offset daytime energy consumption, while hybrid systems with battery backup ensure uninterrupted power supply, reducing dependency on expensive diesel generators.

        Industries like <b>textiles, agro-processing, cold storage, petrol bunks, and service stations</b> can greatly benefit from customized solar solutions tailored to their operational needs.</p><br />
    </div>
  ),
  image: '/images/solar-commercial.jpg',
},
{
  title: 'Hybrid Solar Power Plant',
  description: (
    <div>
      <p>
        A Hybrid Solar Power Plant combines the benefits of both solar photovoltaic (PV) systems and conventional power sources (like grid or diesel generators) to ensure an uninterrupted power supply. This system is designed for areas where grid reliability is low or where 24/7 power availability is critical. It efficiently stores excess solar energy in batteries and intelligently switches between solar, battery, and grid/diesel power based on demand and availability.<br/>
      </p>
      <p><b>specifications:</b>
       <b>System Type:</b> Solar + Battery + Grid/DG (hybrid integration).<br />
       <b>Solar Panel Type:</b>Lithium-ion / Tubular Lead Acid – Deep cycle with smart BMS.<br />
       <b>Inverter Type:</b>Hybrid inverter with MPPT charge controller (single or three-phase).<br />
       <b>Monitoring:</b>Real-time energy tracking with remote monitoring via web/app.<br />
       <b>Applications:</b>Systems available from 1kW to 100kW+ depending on requirement.<br />
       </p>
    </div>
  ),
  image: '/images/solar-hybrid-simple.jpg',
},
{
    title: 'Off-grid Solar Power Plant',
    description:(
      <div>
          <p>Off-grid systems are ideal for remote areas with no grid access. They include battery storage and are self-sufficient, providing energy independence.</p>
          <p><b>Off-Grid Solar Power – Key Highlights:</b><br />
          Off-grid systems operate without grid connection, making them ideal for rural locations, farms, standalone houses, and areas with frequent power cuts.</p>
          <p><b>Solar + Battery Backup for 24/7 power:</b><br />
          These systems store solar energy in batteries, ensuring uninterrupted power supply during nights and cloudy days, eliminating dependency on costly diesel generators.</p>
          <p><b>Zero Electricity Bills with Customizable Solutions:</b><br />
         Off-grid setups are fully self-sustained, resulting in no power bills, and can be designed as per specific energy needs (lights, appliances, equipment).</p>
      </div>
    ),
      
    image: '/images/solar-offgrid.jpg',
},
{
    title: 'Agriculture Solar Power Plant',
    description:(
      <div>
          <p>An agricultural solar power plant combines farming and solar energy production on the same land, maximizing land use and offering numerous benefits.</p>
          <p><b>🌞 Sustainable Power for Farms:</b><br />
          Harness the sun to power agricultural operations—reduce electricity costs and ensure uninterrupted irrigation and equipment use.</p>
          <p><b>🚜 Solar-Powered Irrigation Systems:</b><br />
          Efficient and eco-friendly solar pump systems that support groundwater extraction and crop cultivation without relying on grid power.</p>
          <p><b>🌱 Boost Productivity, Reduce Emissions:</b><br />
         Empower farmers with reliable, clean energy solutions that increase farm productivity while promoting a greener environment.</p>
      </div>
    ),
      
    image: '/images/solar-agriculture.png',
},
];

const solarWaterHeaterSections = [
{
    title: 'FPC Solar Water Header',
    description: (
      <div>
        <p>
          <b>Flat Plate Collector</b> – Non-pressurized system are also called straight-in all-glass vacuum tube solar water heaters. Because the vacuum collector and water tank are sealed by sealing rubber ring, they can not withstand pressure.The non-pressure solar water heater normally uses the non-pressure water shutdown, the efficiency is high and the service life is long. The low-pressure gravity system consists of a vacuum glass tube collector, an insulated storage tank and optional stand parts.
        </p>
        <p><b>Product Features:</b><br />
              – <b>Tubes:</b> 16 borosilicate glass tubes (58mm x 2100mm) with high-efficiency ET-ALN/ALN-SS/CU coating.<br/>
              – <b>Storage Tank:</b> 200-liter horizontal capsule-shaped tank with CRYSTAL BLUE GLASS LINING for corrosion resistance.<br/>
              – <b>Tank Material:</b> Special enamel-grade steel with TIG & MIG welded joints for durability.<br/>
              – <b>Insulation:</b> 50mm thick Cyclopentane foam (38–42 kg/m³ density) for excellent heat retention.<br/>
              – <b>Structure & Coating:</b> Galvanized iron support with UV-stabilized duplex blue powder coating.<br/>
              – <b>System Type:</b> Thermo-siphon circulation, single or series installation; suitable for 0.3 KG/CM² pressure systems.<br/>
        </p>
      </div>
    ),
    image: '/images/ftc.jpg',
},

{
    title: 'ETC Solar Water Header',
    description: (
      <div>
        <p>
          <b>Evacuated Tube Collector</b>
         –Built for performance and durability, this 200-liter pressurized solar water heater combines high-efficiency evacuated tube collectors (ETC) with a rugged, glass-lined storage tank. Designed to handle higher water pressure, it ensures consistent hot water delivery, making it ideal for multi-storey homes and commercial setups.<br />
        </p>
        <p><b>Product Features:</b><br />
              – <b>ETC Tubes:</b> 16 high-efficiency borosilicate glass tubes (58mm x 2100mm) with triple-layer ET-ALN/ALN-SS/CU coating.<br/>
              – <b>Tank Design:</b> Capsule-shaped horizontal tank with CRYSTAL BLUE GLASS LINING for anti-corrosion and pressure endurance.<br/>
              – <b>Pressurized Compatibility:</b> Supports system working pressure of up to 6 bar (6 kg/cm²) with enhanced sealing and reinforced tank build.<br/>
              – <b>Insulation:</b> High-pressure injected Cyclopentane foam insulation (50mm thick, 38–42 kg/m³ density) ensures minimal heat loss.<br/>
              – <b>Structure & Coating:</b> Sturdy GI stand with UV-stabilized blue duplex polyester powder coating for long-lasting outdoor use.<br/>
              – <b>Circulation & Seals:</b> Thermo-siphon based circulation with silicon and EPDM seals for leak-free performance under pressure.<br/>
        </p>
        
      </div>
    ),
    image: '/images/etc.png',
},
];
const solarStreetLightSections = [
  {
    image: '/images/SolarSLCCTV.png',
    model: 'CCTV Street Light',
    power: '90W',
    battery: ' 3.2V 20AH',
    lightingtime: '1 Night',
    
  },  
  {
    image: '/images/semiSL.png',
    model: 'Semi Integrated Light',
    power: '120W/180W/250W',
    battery: ' 3.2V 12Ah-30Ah LiFePo4',
    lightingtime: '12Hrs.',
    
  },
  {
    image: '/images/king-solar.png',
    model: 'King Model',
    power: '300W, 350W',
    battery: '3.2V 25Ah-30Ah LiFePo4',
    lightingtime: '12-16Hrs.',
    
  },
  {
    image: '/images/aero-model.png',
    model: 'Aero Model',
    power: '200W-300W',
    battery: '3.2V 20A-30A LiFePo4',
    lightingtime: '2 Nights',
    
  },
  {
    image: '/images/double-model.jpg',
    model: 'All in One Solar Light',
    power: '30W',
    battery: '3.2V 5A LiFePo4',
    lightingtime: '1 Night',
    
  },
  {
    image: '/images/flood-light.jpg',
    model: 'Flood Light',
    power: '100W/160W',
    battery: ' 3.2V 5A/20A LiFePo4',
    lightingtime: '12Hrs.',
    
  },
  {
    image: '/images/emergency-light.png',
    model: 'Emergency Light',
    power: '50W',
    battery: 'LiFePo4 3.2V 10Ah ',
    lightingtime:'4 Modes',
    function: 'USB Output works as power bank',
    
  },
  {
    image: '/images/gate-light.png',
    model: 'Solar Gate Light',
    power: '5W-10W',
    battery: '3.7V (1800mAh-2000mAh) ',
    lightingtime: '10-12Hrs.',
    
  },
];

const upsBatterySections = [
  {
    image: '/images/home-ups.jpg',
    model: 'Home UPS',
    capacity: '850 VA & Above',
    battery: '40 Ah-220 Ah',
    description: (
      <div>
        <p>
          A<b> home inverter</b>  converts DC power from an external battery into AC power to run household appliances during extended outages.
        </p>
        <p><b>Product Features:</b><br />
              – Two-stage thermal protection.<br/>
              – Short-circuit protection.<br/>
              – 3-stage battery charging.</p>
      </div>
    ),
  },
  {
    image: '/images/hybrid-ups.png',
    model: 'Hybrid UPS',
    capacity: '850 VA-2 KVA',
    battery: '40 Ah- 220 Ah',
    description: (
      <div>
        <p>
          A<b> Hybrid UPS (Uninterruptible Power Supply)</b>  combines features of both traditional UPS and inverter systems. It intelligently toggles between high-efficiency standby mode and the more robust double-conversion ("online") mode based on power quality, offering both energy savings and better protection.
        </p>
        <p><b>Product Features:</b><br />
              – Offers noiseless performance, longer backups, and better battery longevity.<br/>
              – Toggle between standard (10A) and fast (14A) charging modes.<br/>
              – Allows isolating the UPS from mains power when needed.</p>
      </div>
    ),
  },
  {
    image: '/images/online-ups.jpg',
    model: 'Online UPS',
    capacity: '1 KVA & Above',
    battery: '42 Ah – 200 Ah',
    description: (
      <div>
        <p>
          An<b> Online UPS (also called a double-conversion UPS) </b>  continually converts incoming AC power to DC via a rectifier and then back to AC with an inverter—even under normal operation. This ensures that connected devices are always powered by the inverter, providing a seamless power supply without any switching delays.
        </p>
        <p><b>Product Features:</b><br />
              – Since the inverter is always active, there's absolutely no delay during power failures. Critical for sensitive equipment.<br/>
              – Offers a clean, stable, and isolated power output—free from grid disturbances like surges, dips, or noise.<br/>
              – Acts as a robust "electrical firewall" between the utility power and your equipment.</p>
      </div>
    ),
  },
  {
    image: '/images/tubaler.jpg',
    model: 'Tubular Battery',
    capacity: '40 Ah – 220 Ah',
    battery: '12V (Nominal)',
    description: (
      <div>
        <p>
          <p>A <b>Tubular Battery (Flooded Lead-Acid)</b>Lead-acid batteries are a common and affordable type of rechargeable battery widely used in inverters for backup power during outages. They store electrical energy through a chemical reaction between lead, lead dioxide, sulfuric acid, and water</p>
          <p>
            <b>Product Features:</b><br />
            – Simpler and Compact Design.<br />
            – Lower Initial Cost.<br/>
            – Higher Maintenance Needs.</p>
        </p>
      </div>
    ),
  },
  {
    image: '/images/solar.jpg',
    model: 'Solar Battery',
    capacity: '40 Ah – 220 Ah',
    battery: '12V / 24V / 48V (System Dependent)',
    description: (
      <div>
        <p>
         <p>A <b>Solar Battery Lead-Acid(AGM, GD, Tubular)</b>Lead-acid solar batteries are a type of rechargeable battery commonly used in solar power systems to store energy for later use. They consist of lead plates submerged in a sulfuric acid solution, and the electrochemical reactions within these cells allow for the storage and release of electrical energy.</p>
          <p>
            <b>Product Features:</b><br />
            – Lower Initial Cost.<br />
            – Widely available.<br />
            – Lower efficiency(76-85%) Shorter lifespan (500-1000 cycles) and require regular maintenance.<br />
            – Wide Operating Temperature Range.
          </p>
        </p>
      </div>
    ),
  },
  {
    image: '/images/smf.jpg',
    model: 'SMF Battery',
    capacity: '7 Ah – 200 Ah',
    battery: '12V',
    description: (
      <div>
        <p>
         <p>A <b>Sealed Maintenance-Free batteries,</b>are a type of VRLA (Valve Regulated Lead Acid) battery designed to be completely sealed, eliminating the need for regular maintenance like water top-ups. They are designed to be leak-proof and often utilize an internal gel or AGM (Absorbent Glass Mat) technology to immobilize the electrolyte. </p>
          <p>
            <b>Product Features:</b><br />
            – Free from Orientation Constraints.<br />
            – Easy Handling and No Installation Constraints.<br />
            – Excellent Charge Retention and Recovering Ability.<br />
            – Low Self-Discharge.
          </p>
        </p>
      </div>
    ),
  },
  {
    image: '/images/lithium.jpg',
    model: 'Lithium Iron/Ferrous Phosphate Battery',
    capacity: '12 Ah – 300 Ah',
    battery: '12.8V / 24V / 48V / 51.2V (System Dependent)',
    description: (
      <div>
        <p>
         <p>A <b>Lithium iron phosphate (LiFePO4 or LFP) batteries ,</b>are a type of rechargeable lithium-ion battery that uses lithium iron phosphate as the cathode material. They are known for their long cycle life, good thermal stability, and high safety, making them popular in electric vehicles, energy storage systems, and other applications. </p>
          <p>
            <b>Product Features:</b><br />
            – Thermal Stability.<br />
            – Impact Resistance.<br />
            – Chemical Stability.<br />
            – Fast Charging.
          </p>
        </p>
      </div>
    ),
  },
  {
    image: '/images/vechicle.jpg',
    model: 'Vechicle Battery',
    capacity: '5 Ah – 180 Ah',
    battery: '12V',
    description: (
      <div>
        <p>
         <p>A <b>Vechicle (2 Wheeler and 4 Wheeler) batteries ,</b>Two-wheeler batteries are typically 12V, although some older models might use 6V.<br/> Car batteries are larger and have a higher capacity (usually 40-100 Ah or more) to support the greater electrical demands of a car, including the engine, headlights, air conditioning, and other systems.  </p>
          <p>
            <b>Product Features:</b><br />
            – Lightweight.<br />
            – Sealed Maintenance-Free (SMF).<br/>
            – Cold-Cranking Amps (CCA)
          </p>
        </p>
      </div>
    ),
  },
];


const cctvSections = [
  {
    title: 'Bullet Camera (Outdoor)',
    image: '/images/cctv-bullet-outdoor.jpg',
    description: (
      <p>
        <b>Bullet CCTV Cameras</b> are designed for long-range surveillance in outdoor environments. 
        They are weatherproof and deliver clear high-definition footage, even in low-light conditions.
      </p>
    ),
    details: (
      <>
        <p><b>PVC Body:</b> Lightweight, rust-proof plastic for basic weather resistance.</p>
        <p><b>Metal Body:</b> Durable, impact-resistant housing for harsh outdoor conditions.</p>
        <p><b>Mic:</b> Built-in microphone for audio recording alongside video.</p>
        <p><b>Black & White / Color / IR:</b> Infrared night vision with day/night auto-switch.</p>
        <p><b>WiFi:</b> Wireless connectivity for flexible, cable-free video transmission.</p>
        <p><b>SD Card:</b> Built-in microSD slot for local video storage and backup.</p>
        <p><b>Vission Distance:</b> 30 meters to 80 meters (100 to 260 feet)</p>
      </>
    ),
  },
  {
    title: 'Dome Camera (Indoor)',
    image: '/images/cctv-dome-indoor.png',
    description: (
        <p>
          <b>Dome CCTV Cameras</b> offer discreet indoor monitoring with a 360° coverage option. 
          Perfect for retail stores, offices, and residential spaces.
        </p>
    ),
    details: (
      <>
        <p><b>PVC Body:</b> Lightweight, corrosion-free housing for indoor environments.</p>
        <p><b>Metal Body:</b> Strong and stable casing for added durability indoors.</p>
        <p><b>Mic:</b> Integrated microphone for clear indoor audio capture.</p>
        <p><b>Black & White / Color / IR:</b> Full-color daytime video with infrared night vision.</p>
        <p><b>WiFi:</b> Wireless connectivity for easy indoor installation.</p>
        <p><b>SD Card:</b> Local storage via microSD for quick video playback.</p>
        <p><b>Vision Distance:</b>20 meters to 50 meters (65 to 165 feet)</p>
      </>
    ),
  },
  {
    title: 'Dome IP Camera',
    image: '/images/cctv-dome-ip.jpg',
    description: (
        <p>
          <b>IP Dome Cameras</b> use internet protocol for HD video transmission, ideal for modern 
          surveillance systems with remote access capability.
        </p>
    ),
    details: (
      <>
        <p><b>PVC Body:</b> Lightweight, weather-resistant housing for general use.</p>
        <p><b>Metal Body:</b>Rugged construction for long-lasting performance.</p>
        <p><b>Mic:</b> Built-in microphone for synchronized audio and video.</p>
        <p><b>Black & White / Color / IR:</b> High-definition color video with IR night vision.</p>
        <p><b>WiFi:</b> Wireless connectivity for flexible placement without network cables.</p>
        <p><b>SD Card:</b> MicroSD slot for onboard storage and backup recording.</p>
        <p><b>Vision Distance:</b>20 to 60 meters (65 to 200 feet)</p>
      </>
    ),
  },
  {
    title: 'Bullet IP Camera',
    image: '/images/cctv-bullet-ip.jpg',
    description: (
        <p>
          <b>IP Bullet Cameras</b> are perfect for long-distance outdoor monitoring with remote viewing 
          via mobile and desktop applications.
        </p>
    ),
    details: (
      <>
        <p><b>PVC Body:</b> Lightweight, rust-proof housing suitable for outdoor and indoor use.</p>
        <p><b>Metal Body:</b>Heavy-duty, vandal-resistant casing for extreme conditions.</p>
        <p><b>Mic:</b> Built-in microphone for audio recording with video feed.</p>
        <p><b>Black & White / Color / IR:</b> Color video by day, infrared night vision in low light.</p>
        <p><b>WiFi:</b> Wireless connectivity option for easy installation without data cables.</p>
        <p><b>SD Card:</b> Internal microSD slot for local video storage and backup.</p>
        <p><b>Vision Distance:</b>30 to 100 meters (100 to 330 feet)</p>
      </>
    ),
  },
  {
    title: 'Solar  Normal Camera',
    image: '/images/cctv-solar.jpg',
    description: (
        <p>
          <b>Solar-Powered CCTV Cameras</b> offer wireless, eco-friendly surveillance — no electricity 
          required. Great for remote locations.
        </p>
    ),
    details: (
      <>
        <p><b>Solar Panel:</b> Integrated solar panel powers the camera during the day, reducing dependency on electricity.</p>
        <p><b>Battery Backup:</b> Built-in rechargeable battery provides power during night or cloudy conditions.</p>
        <p><b>PVC/Metal Body:</b> Weather-resistant housing suitable for outdoor installations in various environments.</p>
        <p><b>Mic:</b> Built-in microphone supports audio recording along with video surveillance.</p>
        <p><b>IR Night Vision:</b> Infrared LEDs provide clear black-and-white footage in low-light or complete darkness.</p>
        <p><b>WiFi Enabled:</b> Wireless connectivity allows remote viewing via mobile apps or desktop.</p>
        <p><b>SD Card Storage:</b> Supports local video recording with internal microSD slot (up to 128GB or more).</p>
        <p><b>Motion Detection:</b> Sends alerts and starts recording when movement is detected.</p>
        <p><b>Remote Access:</b> Live view and playback available through mobile app (iOS/Android).</p>
      </>
    ),
  },
  {
    title: 'Solar Linkage Camera',
    image: '/images/linkage-solar.jpg',
    description: (
        <p>
          <b>Solar-Powered CCTV Cameras</b> offer wireless, eco-friendly surveillance — no electricity 
          required. Great for remote locations.
        </p>
    ),
    details: (
      <>
          <p><b>Solar Panel Integration:</b> High-efficiency solar panel powers the CCTV system for off-grid operation.</p>
          <p><b>Linkage Function:</b> Automatically links to security systems or alarms for instant threat response.</p>
          <p><b>Metal Body:</b> Rugged, vandal-proof casing designed for harsh outdoor conditions.</p>
          <p><b>Two-Way Audio:</b> Built-in microphone and speaker enable real-time communication.</p>
          <p><b>Color & IR Vision:</b> Full-color video during the day with infrared night vision for 24/7 monitoring.</p>
          <p><b>Network Connectivity:</b> Supports WiFi and Ethernet for stable data transmission.</p>
          <p><b>SD & Cloud Storage:</b> Dual storage options with local microSD card slot and secure cloud backup.</p>
          <p><b>Motion & Sound Detection:</b> Advanced sensors trigger alerts on suspicious movement or noise.</p>
          <p><b>Remote Management:</b> Access live feed and control via dedicated mobile app or web portal.</p>
        </>
    ),
  },
];

// RO & Water Softener Sections
const roPurifierSections = [
  {
    title: "Wall-Mounted RO Purifiers",
    image: "/images/ro-wall-mounted.jpg",
    description:
      "Compact and efficient, perfect for kitchens with limited space. Easy to install and maintain, providing fresh and pure water.",
  },
  {
    title: "Table-Top / Counter-Top RO Purifiers",
    image: "/images/ro-counter-top.jpg",
    description:
      "Portable and space-saving design, ideal for offices and small homes. No plumbing changes required.",
  },
  {
    title: "UV + RO + UF Purifiers",
    image: "/images/ro-uv-uf.jpg",
    description:
      "Triple-layer filtration ensuring bacteria-free and chemical-free drinking water.",
  },
  {
    title: "Alkaline RO Purifiers",
    image: "/images/ro-alkaline.jpg",
    description:
      "Enriched with essential minerals, providing health benefits and balanced pH water.",
  },
  {
    title: "Under-Sink RO Purifiers",
    image: "/images/ro-under-sink.jpg",
    description:
      "Hidden installation for a clean kitchen look, with a separate tap for purified water.",
  },
  {
    title: "Commercial & Industrial RO Purifiers",
    image: "/images/ro-commercial.jpg",
    description:
      "High-capacity purification systems built for hotels, factories, and institutions.",
  },

];

const waterSoftenerSections = [
  {
    title: "Domestic Water Softeners",
    image: "/images/softener-domestic.jpg",
    description:
      "Designed for homes and apartments to prevent scale buildup in taps, showers, and appliances.",
  },
  {
    title: "Commercial Water Softeners",
    image: "/images/softener-commercial.jpg",
    description:
      "Ideal for hotels, restaurants, and hospitals, ensuring long-lasting equipment and soft water supply.",
  },
  {
    title: "Industrial Water Softeners",
    image: "/images/softener-industrial.jpg",
    description:
      "Large-scale solutions for manufacturing units and factories.",
  },
  {
    title: "Automatic Water Softeners",
    image: "/images/softener-automatic.jpg",
    description:
      "Fully automated regeneration process for hassle-free operation.",
  },
  {
    title: "Portable Water Softeners",
    image: "/images/softener-portable.png",
    description:
      "Lightweight and easy to move, perfect for rented homes or temporary setups.",
  },
];


function ProductDetail() {
  const { id } = useParams();
  const productName = productMap[id] || 'Unknown Product';
  const backgroundImages = {
    'solar-plant': '/images/bg-solar-plant.jpg',
    'solar-heater': '/images/bg-solar-heater.jpg',
    'street-light': '/images/bg-solar-light.png',
    'ups-battery':'/images/bg-ups.jpeg',
    'cctv':'/images/bg-cctv.jpg',
    'ro-softener':'/images/bg-ro.jpg',
    'lubricants':'/images/bg-lubricants.png',
    'services':'/images/bg-services.png',
  };

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImages[id] || '/images/default.jpg'})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    minHeight: '100vh',
    padding: '40px 20px',
  };
  
  return (
    <>
    <Helmet>
      <title>RP SMART ENERGY - Products</title>
      <meta
        name="description"
        content="Explore advanced rooftop solar systems, EPC installations, and Maintenance supprot with RP Smart Solar. Smart Energy starts here!"
      />
      <meta name="keywords" content="solar, solar panel, rooftop solar, EPC, Maintenance , Smart Energy, RP Smart Solar" />
    </Helmet>
    <div style={backgroundStyle}>
      <div className="product-detail-overlay container">
        <h1 className="text-center mb-5" style={{ fontSize: 50 }}>
           {productName}
        </h1>
        {/* Solar Power Plant Section */}
            {id === 'solar-plant' &&
              solarPlantSections.map((section, index) => (
                <div
                  key={index}
                  className="mb-5"
                >
                  <div
                    className={`row align-items-center solar-plant-card p-4 rounded shadow ${
                      index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                    }`}
                  >
                    <div className="col-md-6 mb-3 mb-md-0">
                      <img
                        src={section.image}
                        alt={section.title}
                        className="img-fluid rounded"
                      />
                    </div>
                    <div className="col-md-6">
                      <h2>{section.title}</h2>
                      {section.description}
                    </div>
                  </div>
                </div>
              ))}
        {/* Solar Heater Section */}
        {id === 'solar-heater' &&
          solarWaterHeaterSections.map((section, index) => (
            <div
              key={index}
              className={`row align-items-center solar-heater-card mb-5 ${
                index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
              }`}
            >
              <div className="col-md-6"style={{fontWeight:80}}>
                <img
                  src={section.image}
                  alt={section.title}
                  className="img-fluid rounded shadow"
                />
              </div>
              <div className="col-md-6">
                <h3>{section.title}</h3>
                {section.description}
              </div>
            </div>
          ))}
        {/* Street Light Section */}
         {id === 'street-light' && (
            <div className="street-light-section">
              <div className="row">
                {solarStreetLightSections.map((section, index) => (
                  <div key={index} className="col-12 col-sm-6 col-md-3 mb-4">
                    <div className="card h-100 shadow text-center">
                      <img
                        src={section.image}
                        alt={section.model}
                        className="p-3"
                      />
                      <div className="card-body">
                        <h5 className="card-title">{section.model}</h5>
                        <div className="d-flex text-left flex-column">
                          <p className="mb-1"><strong>Power:</strong> {section.power}</p>
                          <p className="mb-1"><strong>Lighting:</strong> {section.lightingtime}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row mt-4">
                <div className="col-12">
                  <div className="alert alert-info text-center" role="alert" style={{ fontSize: '1.1rem' }}>
                    <strong>Warranty:</strong> All Products have 2 Years Warranty. <br />
                    <strong>Battery:</strong> All Products use 3.2V battery storage.
                  </div>
                </div>
              </div>
            </div>
          )}
        {/* UPS & Battery Section */}
        {id === 'ups-battery' && (
          <div className="ups-battery-section mt-5">
            {/* <h2 className="text-center mb-5">UPS & Battery Models</h2> */}
            <div className="row">
              {upsBatterySections.map((section, index) => {
                const isImageLeft = index % 2 === 0;
                return (
                  <div key={index} className="row mb-5">
                    <div className={`col-12 ${!isImageLeft ? 'offset-md-1' : ''}`}>
                      <div
                        className={`d-flex flex-column flex-md-row ${
                          !isImageLeft ? 'flex-md-row-reverse' : ''
                        } align-items-center`}
                      >
                        <img
                          src={section.image}
                          alt={section.model}
                          className="ups-image-hover"
                          style={{
                            width: '50%',
                            maxWidth: '300px',
                            height: '300px',
                            objectFit: 'contain',
                            border: '2px solid black',
                            borderRadius: '10px',
                            margin: '5px',
                          }}
                        />
                        <div className="ms-md-4 me-md-4 mt-4 mt-md-0 text-center text-md-start">
                          <h3>{section.model}</h3>
                          <p><strong>Capacity:</strong> {section.capacity}</p>
                          <p><strong>Battery:</strong> {section.battery}</p>
                          <p>{section.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* CCTV Section */}
        {id === 'cctv' && (
          <div className="cctv-section mt-5">
            {/* <h2 className="text-center mb-2">CCTV Camera Models</h2> */}
            <div className="row">
              {cctvSections.map((section, index) => (
                <div key={index} className="col-12 col-md-4 mb-2">
                  <div className="card ro-card h-100 shadow-lg border-0">
                    <div className="image-hover-wrapper">
                      <img
                        src={section.image}
                        alt={section.title}
                        className="card-img-top"
                        style={{
                          height: '400px',
                          objectFit: 'cover',
                          borderBottom: '3px solid #ddd',
                        }}
                      />
                      <div className="hidden-overlay">
                        <div className="hidden-content">
                          {section.details}
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <h4 className="mb-3">{section.title}</h4>
                      {section.description}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {id === "ro-softener" && (
          <div className="ro-section mt-5">
            <h2 className="text-center mb-5 text-black fw-bold" style={{ fontSize: "2.5rem" }}>
              RO Water Purifiers
            </h2>
            <div className="row">
              {roPurifierSections.map((section, index) => (
                <div key={index} className="col-12 col-md-4 mb-4">
                  <div className="card ro-card h-100 shadow-lg border-0">
                    <img src={section.image} className="card-img-top" alt={section.title} />
                    <div className="card-body">
                      <h3 className="card-title fw-bold">{section.title}</h3>
                      <p className="card-text">{section.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <h2 className="text-center my-5 text-black fw-bold" style={{ fontSize: "2.5rem" }}>
              Water Softeners
            </h2>
            <div className="row">
              {waterSoftenerSections.map((section, index) => (
                <div key={index} className="col-12 col-md-4 mb-4">
                  <div className="card ro-card h-100 shadow-lg border-0">
                    <img src={section.image} className="card-img-top" alt={section.title} />
                    <div className="card-body">
                      <h3 className="card-title fw-bold">{section.title}</h3>
                      <p className="card-text">{section.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {id === 'lubricants' && (
          <div className="lubricants-section my-5 py-5 px-3">
            <h2 className="text-center mb-4 fw-bold">Types of Lubricants</h2>
            <p className="text-center text-bold mb-5">
              Choose from a specialized range of lubricants formulated for maximum protection and efficiency.
            </p>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
              {/* Gear Oil */}
              <div className="col">
                <div className="card h-100 border-0 shadow gear-oil-card">
                  <img
                    src="/images/gear-oil.jpg"
                    alt="Gear Oil"
                    className="card-img-top"
                    style={{ height: '300px', objectFit: 'cover', borderBottom: '4px solid #4a4e69' }}
                  />
                  <div className="card-body">
                    <h3 className="card-title fw-semibold">Gear Oil</h3>
                    <p className="card-text text-muted">
                      Designed for transmissions and differentials, gear oil ensures smooth shifting and superior wear protection even under high pressure.
                    </p>
                  </div>
                </div>
              </div>
              {/* Engine Oil */}
              <div className="col">
                <div className="card h-100 border-0 shadow engine-oil-card">
                  <img
                    src="/images/engine-oil.jpeg"
                    alt="Engine Oil"
                    className="card-img-top"
                    style={{ height: '300px', objectFit: 'cover', borderBottom: '4px solid #1d3557' }}
                  />
                  <div className="card-body">
                    <h3 className="card-title fw-semibold">Engine Oil</h3>
                    <p className="card-text text-muted">
                      Engineered for gasoline and diesel engines, our oils provide thermal stability and long-drain performance in all environments.
                    </p>
                  </div>
                </div>
              </div>
              {/* Coolant Oil */}
              <div className="col">
                <div className="card h-100 border-0 shadow coolant-oil-card">
                  <img
                    src="/images/coolant-oil.jpg"
                    alt="Coolant"
                    className="card-img-top"
                    style={{ height: '300px', objectFit: 'cover', borderBottom: '4px solid #06d6a0' }}
                  />
                  <div className="card-body">
                    <h3 className="card-title fw-semibold">Coolant Oil</h3>
                    <p className="card-text text-muted">
                      Our coolant oils regulate engine temperature and protect against rust, corrosion, and boiling in extreme climates.
                    </p>
                  </div>
                </div>
              </div>
              {/* Brake Oil */}
              <div className="col">
                <div className="card h-100 border-0 shadow brake-oil-card">
                  <img
                    src="/images/brake-oil.png"
                    alt="Brake Oil"
                    className="card-img-top"
                    style={{ height: '300px', objectFit: 'cover', borderBottom: '4px solid #e63946' }}
                  />
                  <div className="card-body">
                    <h3 className="card-title fw-semibold">Brake Oil</h3>
                    <p className="card-text text-muted">
                      Formulated for hydraulic braking systems, brake oil ensures consistent brake performance and high-temperature resistance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
              <div className="d-flex justify-content-between mt-5 flex-wrap">
                {/* Left Content */}
                <div className="text-left" style={{ flex: '1 1 45%' }}>
                  <h3 className="mb-3 fw-bold">Available in:</h3>
                  <p className="text-bold fw-bold indent" style={{paddingLeft:50}}>
                    1L, 4L, 5L, 20L cans and 208L drums for:<br />
                    • Two Wheelers<br />
                    • Four Wheelers<br />
                    • Bus<br />
                    • Trucks<br />
                    • JCB<br />
                    • Lorry<br />
                    • Generators<br />
                    • Industrial Machinery
                  </p>
                </div>
                {/* Right Content */}
                <div className="text-right" style={{ flex: '1 1 45%' }}>
                  <h3 className="mb-3 fw-bold">Brands:</h3>
                  <p className="text-bold fw-bold indent" style={{paddingLeft:50}}>
                    • Ameron PRO<br />
                    • Ameron FLO<br />
                    • Ameron GO
                  </p>
                </div>
              </div>
              <div className="text-center fw-semibold text-primary mt-3">
                    <p>Contact us today for specifications & fleet pricing!</p>
              </div>
            </div>
        )}
      {id === 'services' && (
          <div className="product-detail">
     
      <Services />
    </div>)} 
    {id=== 'rental' &&(
      <div className='product-detail'>

        <RentalProduct />
        </div>)}
      


        
      </div>
    </div>
</>
  );
}

export default ProductDetail;

